import React from 'react';

import styles from '../../pages/listings.module.css';
import { truncate } from '../../utils/utils';

const PortfolioTable = ({ items }) => {
  return (
    <table className='table table-striped table-hover'>
      <thead>
        <tr className={`${styles.headings}`}>
          <th scope='col'>#</th>
          <th scope='col'>Description</th>
          <th scope='col'>Brand</th>
          <th scope='col'>Model</th>
          <th scope='col'>Unit</th>
          <th scope='col'>Price</th>
          <th scope='col'>Currency</th>
        </tr>
      </thead>
      <tbody>
        {items.length > 0 ? (
          items.map((item, idx) => (
            <tr key={item.id} className={styles.rows}>
              <th scope='row'>{idx + 1}</th>
              <td>{truncate(item.description, 20)}</td>
              <td>{item.brand}</td>
              <td>{item.model}</td>
              <td>{item.unit}</td>
              <td>{item.price}</td>
              <td>{item.currency}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={7}>No portfolio items to display ...</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default PortfolioTable;
